@let userServiceCustomerDocumentValue = userService.customerDocument();
@if (userServiceCustomerDocumentValue | isNil: false) {
  <div class="base-container">
    @if (
      userHasAdminPermissions() &&
      userServiceCustomerDocumentValue.customerId !== '1'
    ) {
      <mat-tab-group>
        @let contingentsValue = contingents();
        @let userServiceEditViewValue = userService.editView();
        @let userServiceLoadingUserListValue = userService.loadingUserList();
        <!-- User Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon [icon]="['far', 'users']" size="lg"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.USERS' | translate }}
          </ng-template>
          @if (privacyPolicyAccepted()) {
            <app-user-admin-users-tab
              [productList]="userService.productList()"
              [contingents]="contingentsValue">
            </app-user-admin-users-tab>
          } @else {
            <button
              style="margin: 100px"
              mat-button
              (click)="onCheckDidAcceptPrivacyPolicy()">
              {{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.NOTAGREE' | translate }}
            </button>
          }
        </mat-tab>
        @if (hasSummerWarnings()) {
          <!-- Warning Config Tab -->
          <mat-tab
            [disabled]="
              userServiceEditViewValue || userServiceLoadingUserListValue
            ">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'triangle-exclamation']"
                size="lg"></fa-icon
              >&nbsp;
              {{ 'PRODUCT.USERADMIN.WARNSETTINGS.TITLE' | translate }}
            </ng-template>
            <app-user-admin-warning-tab
              [thresholds]="warnThresolds()"
              [info]="warnInfo()"
              [saving]="savingWarnThresholds()"
              (changeInfo)="onChangeInfo($event)"
              (changeThresholds)="
                onChangeThresholds($event)
              "></app-user-admin-warning-tab>
          </mat-tab>
        }
        <!-- Product Tab-->
        <!--<mat-tab
          [disabled]="
            userServiceEditViewValue || userServiceLoadingUserListValue
          ">
          <ng-template mat-tab-label>
            <fa-icon [icon]="['far', 'cubes']" size="lg"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.PRODUCT' | translate }}
          </ng-template>
          <app-user-admin-product-tab
            [productViewUserData]="productViewUserData()"
            [buttonSelected]="buttonSelected()"
            (expandAll)="onExpandAll($event)"
            (collapseAll)="onCollapseAll($event)"
            (expandedChanged)="onExpandedChanged($event)">
          </app-user-admin-product-tab>
        </mat-tab>-->
        <!-- Contract Tab -->
        @let isBillingMissing =
          !customerContact() ||
          !customerContact().includes('=== RECHNUNGSLEGUNG ===');

        <mat-tab
          [disabled]="
            userServiceEditViewValue || userServiceLoadingUserListValue
          "
          [class.has-highlight-warning]="isBillingMissing">
          <ng-template mat-tab-label>
            <fa-icon [icon]="['far', 'file-signature']" size="lg"></fa-icon
            >&nbsp;
            {{ 'PRODUCT.USERADMIN.CONTRACT.TITLE' | translate }}

            @if (isBillingMissing) {
              <fa-icon
                [icon]="['fas', 'circle-exclamation']"
                class="billing-warning-icon"
                matTooltip="Bitte Rechnungslegung vervollständigen!">
              </fa-icon>
            }
          </ng-template>

          <app-user-admin-contract-tab
            [contractStartDtg]="contractStartDtg()"
            [contractExpiryDtg]="contractExpiryDtg()"
            [contingents]="contingentsValue"
            [showContactEditInfo]="showContactEditInfo()"
            [customerContactLines]="customerContactLines()"
            [customerContact]="customerContact()"
            [showRegionEditInfo]="showRegionEditInfo()"
            [customerInfoLines]="customerInfoLines()"
            [customerInfo]="customerInfo()"
            (editRegion)="onEditRegion()"
            (saveContactInfo)="onSaveContactInfo()"
            (saveRegionInfo)="onSaveRegionInfo()"
            (showContactEdit)="showContactEditInfo.set($event)"
            (showRegionEdit)="showRegionEditInfo.set($event)">
          </app-user-admin-contract-tab>
        </mat-tab>
        <!--Contact Tab-->
        <mat-tab
          [disabled]="
            userServiceEditViewValue || userServiceLoadingUserListValue
          ">
          <ng-template mat-tab-label>
            <fa-icon [icon]="['far', 'envelope']" size="lg"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.CONTACT.TITLE' | translate }}
          </ng-template>
          <app-user-admin-contact-tab
            [contactFormWasSent]="contactFormWasSent()"
            [contactSubjects]="contactSubjects"
            (sendContactForm)="onSendContactForm()">
          </app-user-admin-contact-tab>
        </mat-tab>
      </mat-tab-group>
    } @else {
      @if (userServiceCustomerDocumentValue.customerId === '1') {
        <p class="useradmin-message">
          {{ 'PRODUCT.USERADMIN.NO_ADMIN_PERMISSIONS.MESSAGE_ONE' | translate }}
          <b>{{
            'PRODUCT.USERADMIN.NO_ADMIN_PERMISSIONS.MESSAGE_TWO' | translate
          }}</b
          >.
        </p>
      } @else {
        <p class="useradmin-message">
          {{
            'PRODUCT.USERADMIN.NO_ADMIN_PERMISSIONS.MESSAGE_THREE' | translate
          }}
          <b>{{
            'PRODUCT.USERADMIN.NO_ADMIN_PERMISSIONS.MESSAGE_FOUR' | translate
          }}</b
          >{{
            'PRODUCT.USERADMIN.NO_ADMIN_PERMISSIONS.MESSAGE_FIVE' | translate
          }}
          <a href="mailto:kontakt@wettermanufaktur.de"
            >kontakt&#64;wettermanufaktur.de</a
          >
        </p>
      }
    }
  </div>
}
